/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidationTokenModel } from '../../models/validation-token-model';

export interface GetValidationToken$Plain$Params {

/**
 * id of validationtoken for filter
 */
  validationTokenId: string;
}

export function getValidationToken$Plain(http: HttpClient, rootUrl: string, params: GetValidationToken$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationTokenModel>> {
  const rb = new RequestBuilder(rootUrl, getValidationToken$Plain.PATH, 'get');
  if (params) {
    rb.path('validationTokenId', params.validationTokenId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ValidationTokenModel>;
    })
  );
}

getValidationToken$Plain.PATH = '/api/ValidationToken/{validationTokenId}';
